<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <edit-form
        ref="editForm"
        :formDisabled="formDisabled"
        :amzFtyCheckTaskCode="amzFtyCheckTaskCode"
        :publishDisabled.sync="publishDisabled"
      />
      <div class="d-flex justify-content-end mb-2">
        <el-button
          type="primary"
          size="small"
          v-if="saveDisabled"
          @click="$refs.editForm.save('', $l('INDEX.btn_save') || '保存')"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
        <el-button
          type="success"
          size="small"
          v-if="pageType == 'startCounting'"
          @click="
            $refs.editForm.save(
              'startCounting',
              $l('btn_start_counting') || '开始盘点'
            )
          "
          >{{ $l('btn_start_counting') || '开始盘点' }}</el-button
        >
        <el-button
          type="danger"
          size="small"
          v-if="stopCountingDisabled"
          @click="
            $refs.editForm.save(
              'stopCounting',
              $l('btn_stop_counting') || '盘点终止'
            )
          "
          >{{ $l('btn_stop_counting') || '盘点终止' }}</el-button
        >
        <el-button
          type="success"
          size="small"
          v-if="updateDisabled"
          @click="
            $refs.editForm.save('updateData', $l('btn_update') || '数据调整')
          "
          >{{ $l('btn_update') || '数据调整' }}</el-button
        >
      </div>
    </el-card>
    <el-card shadow="always" class="mt-3" v-if="publishDisabled" style="box-shadow:none">
      <el-tabs v-model="activeName">
        <el-tab-pane
          :label="$l('table_label_firm_offer_document') || '实盘单据'"
          name="ftyCheck"
          lazy
        >
          <FtyCheck
            :amzFtyCheckTaskCode="amzFtyCheckTaskCode"
            :disabled="formDisabled || stopCountingDisabled || updateDisabled"
            @reload="reload"
          />
        </el-tab-pane>
        <el-tab-pane
          :label="
            $l('table_label_inventory_product_statistics') || '盘点产品统计'
          "
          name="ftyCheckDetail"
          lazy
        >
          <FtyCheckDetail :amzFtyCheckTaskCode="amzFtyCheckTaskCode" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import FtyCheck from '../components/fty-check'
import FtyCheckDetail from '../components/fty-check-detail'
export default {
  name: 'ecom-awsBiz-ftyInvCheck-detail',
  components: {
    EditForm,
    FtyCheck,
    FtyCheckDetail,
  },
  data() {
    return { publishDisabled: false, activeName: 'ftyCheck' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    amzFtyCheckTaskCode() {
      return this.params.code
    },
    //禁用表单
    formDisabled() {
      return this.pageType === 'detail'
    },
    saveDisabled() {
      return this.pageType === 'add' || this.pageType === 'edit'
    },
    //盘点终止显示控制
    stopCountingDisabled() {
      return this.pageType == 'stopCounting'
    },
    updateDisabled() {
      return this.pageType == 'update'
    },
  },
  mounted() {},
  methods: {
    reload() {
      this.$refs.editForm.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
